<template>
  <section>
    <!--工具条-->
    <div class="toolbar-container">
      <el-col :span="13">
        <toolbar :buttonList="buttonList" @callFunction="callFunction" :customHandleSearch="customHandleSearch">
        </toolbar>
      </el-col>
      <el-col :span="6">
        <label><span style="width: 100%;">选择考核：</span></label>
        <el-select v-model="defCheck" filterable placeholder="请选择对应考核" @change="checkChange">
          <!-- <el-option :key=0 label="所有考核" :value=0></el-option> -->
          <el-option v-for="item in checks" :key="item.Id" :label="item.Name" :value="item.Id">
          </el-option>
        </el-select>
      </el-col>
    </div>


    <!--列表-->
    <el-table ref="multipleTable" :data="checkModules" tooltip-effect="dark" border v-loading="listLoading"
      style="width: 100%" @selection-change="handleSelectionChange" @row-click="selectCurrentRow" class="custom-tbl">
      <el-table-column type="selection" width="50"> </el-table-column>
      <el-table-column type="index" label="序号" width="80"> </el-table-column>
      <el-table-column prop="ReviewContent" label="评审内容" width="" sortable>
      </el-table-column>
      <el-table-column prop="StIndex" label="标准序号" width="120" sortable :sort-method="customSort">
      </el-table-column>
      <el-table-column prop="Stscore" label="标准分值" width="120" sortable>
      </el-table-column>
      <el-table-column prop="PersonLiableName" label="负责人" width="120" sortable>
      </el-table-column>
      <el-table-column prop="PrimaryDepLs" label="责任科室" width="120" sortable :formatter="formatDepartment">
      </el-table-column>
      <el-table-column prop="AssistDepLs" label="协助科室" width="200" sortable :formatter="formatDepartment">
      </el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" :formatter="formatCreateTime" width="180" sortable>
      </el-table-column>
      <el-table-column prop="CreateBy" label="创建者" width="120" sortable>
      </el-table-column>
      <!-- <el-table-column prop="IsEnable" label="状态" width="" sortable>
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsEnable ? 'success' : 'danger'" disable-transitions>{{ scope.row.IsEnable ? "正常" : "禁用" }}
            </el-tag>
          </template>
</el-table-column> -->
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleLook(scope.row.Id)">查看详情</el-button>
          <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 上下页标 -->
    <el-pagination class="toolbar" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="page" :page-size="pageSize" :page-sizes="[10, 20, 50]"
      layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>

    <!-- 查看详情 -->
    <el-dialog title="查看详情" :visible.sync="lookFormVisible" v-model="lookFormVisible" :close-on-click-modal="false"
      :destroy-on-close="true">
      <el-form :model="lookForm" label-width="80px" ref="lookForm">
        <el-row>
          <el-col :span="17">
            <el-form-item label="所属考核" prop="CheckId">
              <el-select style="width: 100%;" v-model="lookForm.CheckId" filterable placeholder="未找到所属考核，可能已被删除"
                :disabled="true">
                <el-option v-for="item in checks" :key="item.Id" :label="item.Name" :value="item.Id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="分管领导" prop="ResponsibleLeaderId" label-width="">
              <el-select v-model="lookForm.ResponsibleLeaderId" filterable placeholder="未找到分管领导信息，可能已被删除" :disabled="true">
                <el-option v-for="item in users" :key="item.UId"
                  :label="`${item.RealName} ${getDeptNameById(item.DepartmentId)} ${item.LoginName}`" :value="item.UId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <el-form-item label="标准序号" prop="StIndex">
              <el-input style="width: 100%;" v-model="lookForm.StIndex" auto-complete="off" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="重要程度" prop="Level">
              <el-select style="width: 100%;" v-model="lookForm.Level" placeholder="未指定类型" :disabled="true">
                <el-option v-for="item in this.levelTypeList" :key="item.ItemValue" :label="item.ItemText"
                  :value="item.ItemValue">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="责任部门">
              <el-select style="width: 100%;" v-model="singlePrimaryDep" filterable :disabled="true"
                placeholder="未找到所选责任部门，可能已被删除">
                <el-option v-for="dept in depts" :key="dept.key" :label="dept.label" :value="dept.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="负责人" prop="PersonLiableId" label-width="">
              <el-select style="width: 100%;" v-model="lookForm.PersonLiableId" filterable placeholder="请选择模块责任人"
                :disabled="true">
                <el-option v-for="item in users" :key="item.UId"
                  :label="`${item.RealName} ${getDeptNameById(item.DepartmentId)} ${item.LoginName}`" :value="item.UId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="协助部门">
              <el-select style="width: 100%;" v-model="lookForm.AssistDepLs" filterable multiple placeholder="未设置模块协助部门"
                :disabled="true">
                <el-option v-for="dept in depts" :key="dept.key" :label="dept.label" :value="dept.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <el-form-item label="标准分值" prop="Stscore">
              <el-input style="width: 100%;" type="number" v-model="lookForm.Stscore" auto-complete="off"
                :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="合格线" prop="Threshold">
              <el-slider style="width : 100%" v-model="lookForm.Threshold" :format-tooltip="formatTooltip" :step="10" disabled
                show-input></el-slider>
            </el-form-item>
          </el-col>
        </el-row>


        <el-form-item label="评审内容" prop="ReviewContent">
          <el-input style="width : 100%;height: 100%" :rows="5" v-model="lookForm.ReviewContent" type="textarea"
            auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="标准概述" prop="Stoverview">
          <el-input style="width : 100%" v-model="lookForm.Stoverview" :rows="5" type="textarea" auto-complete="off"
            :disabled="true"></el-input>
        </el-form-item>
        <!-- <el-form-item label="顺序号" prop="SortId">
          <el-input v-model="lookForm.SortId" auto-complete="off" :disabled="true"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="状态" prop="IsEnable">
            <el-select v-model="addForm.IsEnable" placeholder="请选择状态">
              <el-option label="激活" value="true"></el-option>
              <el-option label="禁用" value="false"></el-option>
            </el-select>
          </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="lookFormVisible = false">确定</el-button>
      </div>
    </el-dialog>

    <!-- 新增 -->
    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false"
      :destroy-on-close="true">
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">

        <el-row>
          <el-col :span="17">
            <el-form-item label="所属考核" prop="CheckId">
              <el-select style="width: 100%;" v-model="addForm.CheckId" filterable placeholder="请选择对应考核"
                @change="getAddStIndex(addForm.CheckId)">
                <el-option v-for="item in checks" :key="item.Id" :label="item.Name" :value="item.Id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="分管领导" prop="ResponsibleLeaderId" label-width="">
              <el-select v-model="addForm.ResponsibleLeaderId" filterable placeholder="请选择模块分管领导">
                <el-option v-for="item in users" :key="item.UId"
                  :label="`${item.RealName} ${getDeptNameById(item.DepartmentId)} ${item.LoginName}`" :value="item.UId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <el-form-item label="标准序号" prop="StIndex">
              <el-input v-model="addForm.StIndex" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="重要程度" prop="Level">
              <el-select style="width: 100%;" v-model="addForm.Level" placeholder="请选择类型">
                <el-option v-for="item in this.levelTypeList" :key="item.ItemValue" :label="item.ItemText"
                  :value="item.ItemValue">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="责任部门" prop="PrimaryDepLs">
              <el-select v-model="singlePrimaryDep" filterable @change="addupdatePrimaryDepLs" placeholder="请选择模块责任部门">
                <el-option v-for="dept in depts" :key="dept.key" :label="dept.label" :value="dept.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="负责人" prop="PersonLiableId" label-width="">
              <el-select v-model="addForm.PersonLiableId" filterable placeholder="请选择模块责任人">
                <el-option v-for="item in users" :key="item.UId"
                  :label="`${item.RealName} ${getDeptNameById(item.DepartmentId)} ${item.LoginName}`" :value="item.UId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="协助部门">
              <el-select style="width: 100%;" v-model="addForm.AssistDepLs" filterable multiple placeholder="请选择模块协助部门">
                <el-option v-for="dept in depts" :key="dept.key" :label="dept.label" :value="dept.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <el-form-item label="标准分值" prop="Stscore">
              <el-input style="width: 100%;" type="number" v-model="addForm.Stscore" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="合格线" prop="Threshold">
              <el-slider style="width : 100%" v-model="addForm.Threshold" :format-tooltip="formatTooltip " :step="10"
                show-input></el-slider>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="评审内容" prop="ReviewContent">
          <el-input style="width : 100%;height: 100%" :rows="5" v-model="addForm.ReviewContent" type="textarea"
            auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="标准概述" prop="Stoverview">
          <el-input style="width : 100%;height: 100%" :rows="5" v-model="addForm.Stoverview" type="textarea"
            auto-complete="off"></el-input>
        </el-form-item>


        <!-- <el-form-item label="顺序号" prop="SortId">
          <el-input v-model="addForm.SortId" auto-complete="off"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="状态" prop="IsEnable">
            <el-select v-model="addForm.IsEnable" placeholder="请选择状态">
              <el-option label="激活" value="true"></el-option>
              <el-option label="禁用" value="false"></el-option>
            </el-select>
          </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false"
      :destroy-on-close="true">
      <el-form :model="editForm" label-width="80px" :rules="addFormRules" ref="editForm">
        <el-row>
          <el-col :span="17">
            <el-form-item label="所属考核" prop="CheckId">
              <el-select style="width: 100%;" v-model="editForm.CheckId" filterable placeholder="请选择对应考核"
                @change="getEditStIndex(editForm.CheckId)">
                <el-option v-for="item in checks" :key="item.Id" :label="item.Name" :value="item.Id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="分管领导" prop="ResponsibleLeaderId" label-width="">
              <el-select v-model="editForm.ResponsibleLeaderId" filterable placeholder="请选择模块分管领导">
                <el-option v-for="item in users" :key="item.UId"
                  :label="`${item.RealName} ${getDeptNameById(item.DepartmentId)} ${item.LoginName}`" :value="item.UId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <el-form-item label="标准序号" prop="StIndex">
              <el-input v-model="editForm.StIndex" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="重要程度" prop="Level">
              <el-select style="width: 100%;" v-model="editForm.Level" placeholder="请选择类型">
                <el-option v-for="item in this.levelTypeList" :key="item.ItemValue" :label="item.ItemText"
                  :value="item.ItemValue">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="责任部门" prop="PrimaryDepLs">
              <el-select style="width: 100%;" v-model="singlePrimaryDep" filterable @change="editupdatePrimaryDepLs"
                placeholder="未找到所选责任部门，可能已被删除">
                <el-option v-for="dept in depts" :key="dept.key" :label="dept.label" :value="dept.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="负责人" prop="PersonLiableId" label-width="">
              <el-select style="width: 100%;" v-model="editForm.PersonLiableId" filterable placeholder="请选择模块责任人">
                <el-option v-for="item in users" :key="item.UId"
                  :label="`${item.RealName} ${getDeptNameById(item.DepartmentId)} ${item.LoginName}`" :value="item.UId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="协助部门">
              <el-select style="width: 100%;" v-model="editForm.AssistDepLs" filterable multiple
                placeholder="请选择模块协助部门">
                <el-option v-for="dept in depts" :key="dept.key" :label="dept.label" :value="dept.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>

          <el-col :span="4">
            <el-form-item label="标准分值" prop="Stscore">
              <el-input style="width: 100%;" type="number" v-model="editForm.Stscore" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="合格线" prop="Threshold">
              <el-slider style="width : 100%" v-model="editForm.Threshold" :format-tooltip="formatTooltip" :step="10"
                show-input></el-slider>
            </el-form-item>
          </el-col>
        </el-row>


        <el-form-item label="评审内容" prop="ReviewContent">
          <el-input style="width : 100%" :rows="5" v-model="editForm.ReviewContent" type="textarea"
            auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="标准概述" prop="Stoverview">
          <el-input style="width : 100%" :rows="5" v-model="editForm.Stoverview" type="textarea"
            auto-complete="off"></el-input>
        </el-form-item>


        <!-- <el-form-item label="顺序号" prop="SortId">
          <el-input v-model="editForm.SortId" auto-complete="off"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="状态" prop="IsEnable">
            <el-select v-model="editForm.IsEnable" placeholder="请选择状态">
              <el-option v-for="item in statusList" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  GetChecks,
  GetCheckModule,
  GetCheckModuleById,
  GetCheckModuleStIndex,
  DeleteCheckModuleByIds,
  AddCheckModule,
  PutCheckModule,
} from "../../api/RatingManage/RatingManage";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import {
  GetDepartmentList,
  getUsers,
} from "../../api/api";
import {
  GetSysDictByCode,
} from "../../api/SysDictionary/SysDictionary";

export default {
  components: { Toolbar },
  data() {
    return {
      filters: {
        name: "",
      },
      checks: [],
      depts: [],
      users: [],
      levelTypeList: [],
      singlePrimaryDep: '', // 用于单选下拉框的绑定
      checkModules: [],
      total: 0,
      buttonList: [],
      currentRows: [],
      page: 1,
      pageSize: 10,
      listLoading: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      lookFormVisible: false, //查看界面是否显示
      lookLoading: false,
      defCheck: 0,
      addFormRules: {
        CheckId: [
          { required: true, message: "请选择考核类型", trigger: "blur" },
        ],
        PrimaryDepLs: [
          { required: true, message: "请选择责任科室", trigger: "blur" },
        ],
        StIndex: [
          { required: true, message: "请输入标准序号", trigger: "blur" },
        ],
        PersonLiableId: [
          { required: true, message: "请选择负责人", trigger: "blur" },
        ],
        ResponsibleLeaderId: [
          { required: true, message: "请选择分管领导", trigger: "blur" },
        ],
        Level: [
          { required: true, message: "请选择模块等级", trigger: "blur" },
        ],
        ReviewContent: [
          { required: true, message: "请输入评审内容", trigger: "blur" },
          { max: 500, message: '评审内容不能超过500个字符', trigger: 'blur' }
        ],
        Stoverview: [
          { required: true, message: "请输入标准概述", trigger: "blur" },
          { max: 500, message: '标准概述不能超过500个字符', trigger: 'blur' }
        ],
      },

      //查看界面数据
      lookForm: {
        CheckId: 0,
        Id: 0,
        ReviewContent: "",
        Stoverview: "",
        StIndex: "",
        Stscore: 0,
        SortId: 0,
        PrimaryDepLs: [],
        AssistDepLs: [],
        PersonLiableId: 0,
      },
      //新增界面数据
      addForm: {
        ReviewContent: "",
        Stoverview: "",
        StIndex: "",
        Stscore: 0,
        SortId: 0,
        PrimaryDepLs: [],
        AssistDepLs: [],
      },
      //编辑界面数据
      editForm: {
        CheckId: 0,
        Id: 0,
        ReviewContent: "",
        Stoverview: "",
        StIndex: "",
        Stscore: 0,
        SortId: 0,
        PrimaryDepLs: [],
        AssistDepLs: [],
        PersonLiableId: 0,
      },
    };
  },
  computed: {},
  methods: {
    handleSelectionChange(selection) {
      this.currentRows = selection;
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    addupdatePrimaryDepLs(selectedValue) {
      this.addForm.PrimaryDepLs = selectedValue ? [selectedValue] : [];
      const dept = this.depts.find(dept => dept.key === selectedValue);
      const user = this.users.find(user => user.UId === dept.uid);
      if (user)
        this.addForm.PersonLiableId = dept.uid;
      else
        this.addForm.PersonLiableId = null;
    },
    editupdatePrimaryDepLs(selectedValue) {
      this.editForm.PrimaryDepLs = selectedValue ? [selectedValue] : [];
      const dept = this.depts.find(dept => dept.key === selectedValue);
      const user = this.users.find(user => user.UId === dept.uid);
      if (user)
        this.editForm.PersonLiableId = dept.uid;
      else
        this.editForm.PersonLiableId = null;
    },
    selectCurrentRow(row) {
      const isSelected = this.currentRows.includes(row);
      if (isSelected) {
        // 如果行已经选中，则取消选中
        const index = this.currentRows.indexOf(row);
        this.currentRows.splice(index, 1);
        this.$refs.multipleTable.toggleRowSelection(row, false);
      } else {
        // 如果行未选中，则添加选中
        this.currentRows.push(row);
        this.$refs.multipleTable.toggleRowSelection(row, true);
      }
    },
    customSort(a, b) {
      const getIndex = (str) => {
        // 将标准序号字符串转换为可以比较的数值
        const parts = str.split('.').map(part => parseFloat(part));
        let index = 0;
        for (let i = 0; i < parts.length; i++) {
          index += parts[i] / Math.pow(100, i);
        }
        return index;
      };

      const indexA = getIndex(a.StIndex);
      const indexB = getIndex(b.StIndex);

      if (indexA > indexB) return 1;
      if (indexA < indexB) return -1;
      return 0;
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(
          new Date(row.CreateTime),
          "yyyy-MM-dd hh:mm:ss"
        );
    },
    formatTooltip(val) {
      return val / 100;
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getModuleLs();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1; // 当更改分页大小时，重置为第一页
      this.getModuleLs();
    },
    checkChange(){
      this.page=1;
      this.getModuleLs();
    },
    getDeptNameById(deptId) {
      // 遍历部门数组，寻找与deptId匹配的部门对象
      for (var i = 0; i < this.depts.length; i++) {
        if (this.depts[i].key === deptId) {
          return this.depts[i].label; // 返回找到的部门名称
        }
      }
      return "未知部门"; // 如果找不到对应ID的部门，返回默认值或者空字符串，根据需求
    },
    formatDepartment(row, column, cellValue) {
      // 根据 column.property (PrimaryDepLs 或 AssistDepLs) 获取对应的科室列表
      const departmentIds = row[column.property];
      if (departmentIds && departmentIds.length > 0) {
        return departmentIds.map(id => {
          const dept = this.depts.find(dept => dept.key === id);
          return dept ? dept.label : id;
        }).join(', ');
      } else {
        return '无'; // 或者其他默认文本
      }
    },
    async getchecks() {
      await GetChecks().then((res) => {
        this.checks = res.data.response;
        if (this.checks.length === 0) {
          this.$message({
            type: 'warning',
            message: '请先创建考核'
          });
          return
        }
        else
          this.defCheck = this.checks[0].Id;

      });
    },
    async getDeptList() {
      await GetDepartmentList().then((res) => {
        if (res.status == 200) {
          res.data.response.forEach((element) => {
            this.depts.push({ key: element.Id, label: element.Name, uid: element.Uid });
          });
        }
      });
    },
    //获取级别类型字典
    getLevelTypes() {
      let para = {
        code: "Module_Level",
      };
      GetSysDictByCode(para).then((res) => {
        this.levelTypeList = res.data.response;
        //NProgress.done();
      });
    },
    getUsersQuery() {
      getUsers().then((res) => {
        if (res.data.success) {
          this.users = res.data.response;
        }
      });
    },
    //获取考核模块信息
    getModuleLs() {
      let para = {
        page: this.page,
        key: this.filters.name,
        pageSize: this.pageSize,
        checkId: this.defCheck,
      };
      this.listLoading = true;
      GetCheckModule(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.checkModules = res.data.response.data;
        this.checkModules.forEach(cm => cm.Threshold = cm.Threshold * 100);
        this.listLoading = false;
        //NProgress.done();
      });
    },
    customHandleSearch(val) {
      this.filters = {
        name: val,
      };
      this.getModuleLs();
    },
    getAddStIndex(checkId) {
      GetCheckModuleStIndex({ checkId }).then((res) => {
        this.addForm.StIndex = res.data.response;
      });
    },
    getEditStIndex(checkId) {
      GetCheckModuleStIndex({ checkId }).then((res) => {
        this.editForm.StIndex = res.data.response;
      });
    },
    //显示查看/新增/编辑界面
    handleLook(Id) {
      GetCheckModuleById({ Id }).then((res) => {
        this.lookForm = res.data.response;
        this.lookForm.Threshold = this.lookForm.Threshold * 100;
        this.lookForm.ResponsibleLeaderId =this.lookForm.ResponsibleLeaderId==="0"?null:this.lookForm.ResponsibleLeaderId;
      });
      this.singlePrimaryDep = this.editForm.PrimaryDepLs.length > 0 ? this.editForm.PrimaryDepLs[0] : '';
      this.lookFormVisible = true;
    },
    handleAdd() {
      this.addForm = {
        ReviewContent: "",
        Stoverview: "",
        StIndex: "",
        Stscore: 0,
        SortId: 0,
        PrimaryDepLs: [],
        AssistDepLs: [],
        Threshold: 60,
        PersonLiableId: null,
        ResponsibleLeaderId:null,
      };
      this.singlePrimaryDep = null;
      this.addFormVisible = true;
    },
    //新增考核模块信息
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);
            para.Threshold = para.Threshold / 100;
            AddCheckModule(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              this.addLoading = false;
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getModuleLs();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //删除考核模块信息
    handleDel(row) {
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("该操作会同步删除下属考核项，确认删除该模块吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = [row.Id];
          DeleteCheckModuleByIds(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.getModuleLs();
          });
        })
        .catch(() => { });
    },
    handleDels() {
      let rows = this.currentRows;
      if (!rows || rows.length === 0) {
        this.$message({
          message: "请选择要删除的数据！",
          type: "error",
        });
        return;
      }
      this.$confirm("该操作会同步删除下属考核项，确认删除选中的模块吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = rows.map((row) => row.Id);
          DeleteCheckModuleByIds(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.currentRows = [];
              this.$refs.multipleTable.clearSelection();
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.getModuleLs();
          });
        })
        .catch(() => { });
    },
    handleEdit(row) {
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      this.editForm = Object.assign({}, row);
      this.singlePrimaryDep = this.editForm.PrimaryDepLs.length > 0 ? this.editForm.PrimaryDepLs[0] : '';
      this.editForm.ResponsibleLeaderId =this.editForm.ResponsibleLeaderId==="0"?null:this.editForm.ResponsibleLeaderId;
      this.editFormVisible = true;
    },
    editSubmit: function () {
      //保存
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);
            para.Threshold = para.Threshold / 100;
            PutCheckModule(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getModuleLs();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    async setup() {
      await this.getchecks();
      this.getModuleLs();
      this.getDeptList();
      this.getUsersQuery();
      this.getLevelTypes();
      let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      this.buttonList = getButtonList(this.$route.path, routers);
    },
  },
  watch: {
    'editForm.PrimaryDepLs': {
      handler(newVal) {
        this.singlePrimaryDep = newVal.length > 0 ? newVal[0] : '';
      },
      immediate: true,
      deep: true
    },
    'lookForm.PrimaryDepLs': {
      handler(newVal) {
        this.singlePrimaryDep = newVal.length > 0 ? newVal[0] : '';
      },
      immediate: true,
      deep: true
    },
  },
  mounted() {
    this.setup();
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.custom-tbl /deep/ .el-table__header .el-checkbox {
  display: block;
}
</style>